import React from 'react';
import { Icon } from 'antd';
import Button from 'Components/Shared/Button/Button';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import WarningWrapper from 'Components/Shared/WarningWrapper/WarningWrapper';
import OrderCancelConfirm from 'Components/OrderCancelConfirm/OrderCancelConfirm';

interface IProps {
  isShowingWarningEmpty?: boolean;
  isShowingWarningInvalid?: boolean;
  onBack: () => void;
  onNext: () => void;
}

const FooterButtons: React.SFC<IProps> = ({
  isShowingWarningEmpty,
  isShowingWarningInvalid,
  onBack,
  onNext,
}) => (
  <div className='order-layout-footer'>
    { onBack &&
      <OrderCancelConfirm 
        placement='topLeft'
        triggerType='back-click' 
        onConfirm={ onBack } 
      >
        <Button color='transparent'>
          <Icon type='left' />
          <FormattedText
            displayName='Tillbaka'
            formattedName='order.button.previous'
          />
        </Button>
      </OrderCancelConfirm>
    }
    { onNext && 
      <WarningWrapper
        isShowingWarning={ isShowingWarningEmpty || isShowingWarningInvalid }
        displayName={ 
          isShowingWarningEmpty ? 
          'Välj platser' : 
          'Ogiltigt val av platser' 
        }
        formattedName={ 
          isShowingWarningEmpty ? 
          'order.seatpicker.pickseats' : 
          'order.seatpicker.invalid' 
        }
      >
        <Button onClick={ onNext }>
          <FormattedText
            displayName='Gå vidare'
            formattedName='order.button.next'
          />
          <Icon type='right' />
        </Button>
      </WarningWrapper>
    }
  </div>
);

export default FooterButtons;


// WEBPACK FOOTER //
// ./src/components/PickSeatManually/FooterButtons/FooterButtons.tsx